import {
  LOADING_AGENCIES,
  LOADING_AGENCIES_SUCCESS,
  LOADING_AGENCIES_FAILURE
} from '../constants/agenciesTypes'

// A brand's list survives a refetch and a failed refetch: the Associations tab refetches on
// every mount, and the connection form reads this slice but only fetches when it is empty.
const previousData = (state, brandId) => {
  const data = state[brandId] && state[brandId].data
  return data ? data : null
}

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case LOADING_AGENCIES:
      return {
        ...state,
        [actions.brandId]: {
            loading: true,
            success: null,
            data: previousData(state, actions.brandId)
          }
        }
    case LOADING_AGENCIES_SUCCESS:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: true,
          data: actions.data ? [...actions.data] : []
        }
      }
    case LOADING_AGENCIES_FAILURE:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: false,
          data: previousData(state, actions.brandId),
          errors: actions.errors
        }
      }
    default:
      return state
  }
}
